export const rightImages = [
  [
    {
      height: 670,
      width: 703,
    },
    {
      height: 506,
      width: 548,
    },
    {
      height: 549,
      width: 703,
    },
  ],
  [
    {
      height: 550,
      width: 560,
    },
    {
      height: 404,
      width: 444,
    },
    {
      height: 437,
      width: 560,
    },
  ],
  [
    {
      height: 469,
      width: 476,
    },
    {
      height: 345,
      width: 378,
    },
    {
      height: 371,
      width: 475,
    },
  ],
  [
    {
      height: 377,
      width: 380,
    },
    {
      height: 277,
      width: 304,
    },
    {
      height: 296,
      width: 380,
    },
  ],
  [
    {
      height: 377,
      width: 380,
    },
    {
      height: 277,
      width: 304,
    },
    {
      height: 296,
      width: 380,
    },
  ],
];

export const textSizes = [
  {
    accent: 18,
    name: 75,
    textSection: 16,
  },
  {
    accent: 18,
    name: 75,
    textSection: 16,
  },
  {
    accent: 15,
    name: 60,
    textSection: 13,
  },
  {
    accent: 13,
    name: 50,
    textSection: 11,
  },
  {
    accent: 13,
    name: 50,
    textSection: 11,
  },
];

export const orb = [260, 208, 177, 140, 140];

export const button = [
  {
    height: 70,
    width: 240,
    radius: 25,
    size: 20,
  },
  {
    height: 56,
    width: 192,
    radius: 25,
    size: 20,
  },
  {
    height: 47,
    width: 160,
    radius: 15,
    size: 15,
  },
  {
    height: 34,
    width: 117,
    radius: 10,
    size: 12,
  },
  {
    height: 34,
    width: 117,
    radius: 10,
    size: 12,
  },
];

export const backgroundTriangles = [
  {
    height: 1215,
    width: 1736,
  },
  {
    height: 969,
    width: 1385,
  },
  {
    height: 969,
    width: 1365,
  },
  {
    height: 727,
    width: 1024,
  },
  {
    height: 727,
    width: 1024,
  },
];
